import styled from "styled-components";

export const ServiceRightContainer = styled.div`
  flex-shrink: 0;
  position: relative;
`;

export const ServiceRightOuterBox = styled.div`
  width: 34.5rem;
  height: 41.19rem;
  position: relative;
  flex-shrink: 0;
  border-radius: 20px;
  background-color: #e4e3ed;
  box-shadow: 0px -3.7876105308532715px 60.31769943237305px 4.734513282775879px #c0c1cf61;
  @media screen and (min-width: 321px) and (max-width: 767px) {
    width: 19.25rem;
    height: 48.375rem;
  }

  @media screen and (max-width: 320px) {
    width: 16.81rem;
    height: 48.375rem;
  }
`;

export const ServiceRightInnerBox = styled.div`
  width: 32.875rem;
  height: 36.875rem;
  flex-shrink: 0;
  border-radius: 20px;
  background: var(--General-White, #fff);
  box-shadow: 0px -3.788px 60.318px 4.735px rgba(192, 193, 207, 0.38);
  position: absolute;
  left: 50px;
  top: 30px;
  z-index: 11;
  @media screen and (min-width: 321px) and (max-width: 767px) {
    width: 19.25rem;
    height: 45.25rem;
  }

  @media screen and (max-width: 320px) {
    width: 17.81rem;
    height: 45.25rem;
    left: 10px;
    top: 20px;
  }
`;
